import _ from "lodash";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { connect } from "react-redux";
import { selectSingupFeature } from "Actions";

class FeatureIcon extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: false,
      style: classNames("col-md-2", "horizontal-align-center", "box"),
    };

    this.onFeatureClick = this.onFeatureClick.bind(this);
  }

  onFeatureClick() {
    var selectedVal = !this.state.selected;
    var iconstyle;

    if (selectedVal) {
      iconstyle = classNames(
        "col-md-3",
        "horizontal-align-center",
        "box-selected"
      );
    } else {
      iconstyle = classNames("col-md-3", "horizontal-align-center", "box");
    }
    this.setState({ selected: selectedVal, style: iconstyle });
    this.props.selectSingupFeature(this.props.feature);
  }

  render() {
    var normalIconUrl = `../../style/images/icons/${this.props.feature.displaytabname}.png`;
    var hoveredIconUrl = `../../style/images/icons/${this.props.feature.displaytabname}-Fill.png`;
    var selectedIconUrl = `../../style/images/icons/${this.props.feature.displaytabname}-White.png`;
    var icon_title = _.replace(this.props.feature.displaytabname, "-", " ");
    return (
      <div className={this.state.style} onClick={this.onFeatureClick}>
        <div>
          <img className="normal" src={normalIconUrl} alt="normal" />
          <img className="hovered" src={hoveredIconUrl} alt="hovered" />
          <img className="selected" src={selectedIconUrl} alt="selected" />
        </div>
        <div className="icon-title">{icon_title}</div>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, { selectSingupFeature })(FeatureIcon);
